import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '@/style/page.less';
import { getStartEnd } from '@/utils';
import { addItem } from '@/api/shoppingcart';
import { createOrder, checkLogin, getTicketInfo } from '@/api';
import Protocol from '@/components/Protocol';
import ContactSelector from '@/components/contacts/ContactSelector'; // import moment from 'moment'

import dayjs from 'dayjs';
import Steps from '@/components/Steps';
import PageTitle from '@/components/PageTitle';
import PriceCalendar from '@/components/PriceCalendar';
export default {
  components: {
    Steps: Steps,
    Protocol: Protocol,
    PageTitle: PageTitle,
    PriceCalendar: PriceCalendar,
    ContactSelector: ContactSelector
  },
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      } else if (isNaN(value) || value.length !== 11) {
        callback(new Error('手机号码格式错误'));
      } else {
        callback();
      }
    };

    var validateIdentify = function validateIdentify(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      if (value.length !== 15 && value.length !== 18) {
        callback(new Error('身份证号格式错误'));
      } else {
        callback();
      }
    };

    return {
      validatePhone: validatePhone,
      validateIdentify: validateIdentify,
      loading: false,
      checked: false,
      pageLoading: false,
      addCartLoading: false,
      ticketType: null,
      datePrices: [],
      datePricesMap: {},
      form: {
        count: 1,
        playDate: '',
        buyer_name: '',
        buyer_phone: '',
        buyer_identify: '',
        buyer_papers_type: 'ID_CARD',
        tickets: [{
          guest_identify: '',
          guest_name: '',
          guest_phone: '',
          play_date_begin: '',
          price: '',
          ticket_type_id: ''
        }]
      },
      rules: {
        buyer_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        buyer_phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        buyer_identify: [{
          required: true,
          validator: validateIdentify,
          trigger: 'blur'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate() {
          return false;
        },
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }]
      }
    };
  },
  computed: {
    totalPrice: function totalPrice() {
      return ((this.datePricesMap[this.form.playDate] || 0) * this.form.count).toFixed(2) - 0;
    },
    projectConfig: function projectConfig() {
      return this.$store.state.projectConfig;
    },
    leftNum: function leftNum() {
      var tickets = this.form.tickets.filter(function (i) {
        return i.guest_name && i.guest_identify;
      });
      return this.form.count - tickets.length;
    }
  },
  watch: {
    'form.count': {
      handler: function handler(val) {
        while (this.form.tickets.length < val) {
          var ticket = {
            guest_identify: '',
            guest_name: '',
            guest_phone: '',
            play_date_begin: '',
            price: '',
            ticket_type_id: ''
          };
          this.form.tickets.push(ticket);
        }

        if (this.form.tickets.length > val) {
          this.form.tickets.splice(val);
        }
      }
    }
  },
  created: function created() {
    this.init();
    this.form.buyer_name = this.$localStore.get('buyer_name') || '';
    this.form.buyer_phone = this.$localStore.get('buyer_phone') || '';
    this.form.buyer_identify = this.$localStore.get('buyer_identify') || '';
  },
  methods: {
    init: function init() {
      var _this = this;

      checkLogin().then(function (res) {
        if (!res.data.extraInfo) {
          localStorage.removeItem('pc_token');

          _this.$router.push({
            name: 'login'
          });
        }
      });
      var ticketId = this.$route.params.id;

      if (ticketId) {
        this.pageLoading = true;
        getTicketInfo({
          id: ticketId
        }).then(function (res) {
          _this.ticketType = res.data.extraInfo; // 获取日历价格

          _this.getDatePrice();
        });
      } else {
        this.$router.push({
          name: 'ticket'
        });
        return;
      }

      this.pickerOptions.disabledDate = this.getDisabledDate;
    },
    addShoppingCart: function addShoppingCart() {
      var _this2 = this;

      var order = this.getOrderInfo();

      if (this.ticketType.player_need_realname && order.tickets.some(function (item) {
        return !item.guest_name || !item.guest_identify;
      })) {
        this.$message.error('请完善出行人信息');
        return;
      }

      this.addCartLoading = true;
      addItem(order.tickets).then(function (res) {
        _this2.$message.success('添加成功');

        _this2.$store.dispatch('getCartItems');
      }).finally(function () {
        _this2.addCartLoading = false;
      });
    },
    getDatePrice: function getDatePrice() {
      var _this3 = this;

      var startEnd = getStartEnd(this.ticketType);
      this.ticketStart = startEnd.start; // YYYY-MM-DD

      this.ticketEnd = startEnd.end; // let today = moment()
      // let tomorrow = moment().add(1, 'days')

      var params = {
        id: this.$route.params.id,
        start: this.ticketStart,
        end: this.ticketEnd
      };
      this.form.playDate = startEnd.start;
      getTicketInfo(params).then(function (res) {
        _this3.datePrices = res.data.extraInfo.prices;
        var datePricesMap = {};

        _this3.datePrices.forEach(function (item) {
          datePricesMap[item.date] = item.price;
        });

        _this3.datePricesMap = datePricesMap;
      }).finally(function () {
        _this3.pageLoading = false;
      });
    },
    getOrderInfo: function getOrderInfo() {
      var _this4 = this;

      var order = Object.assign({}, this.form);
      order.price = this.totalPrice;
      order.buyer_name = this.ticketType.need_realname ? order.buyer_name : '';
      order.buyer_identify = this.ticketType.need_realname ? order.buyer_identify : '';
      order.tickets.forEach(function (guest) {
        guest.batch_type_id = 0;
        guest.ticket_type_id = _this4.ticketType.id;
        guest.price = _this4.datePricesMap[_this4.form.playDate];
        guest.play_date_begin = _this4.formatDate(_this4.form.playDate);
      });
      return order;
    },
    toPayPage: function toPayPage() {
      var _this5 = this;

      if (!this.form.playDate) {
        this.$message.error('请选择游玩日期');
        return;
      }

      var order = this.getOrderInfo();

      if (this.ticketType.player_need_realname && order.tickets.some(function (item) {
        return !item.guest_name || !item.guest_identify;
      })) {
        this.$message.error('请完善出行人信息');
        return;
      }

      this.$refs.buyerForm.validate(function (valid) {
        if (valid) {
          if (!_this5.checked) {
            _this5.$message.error('请确认勾选已阅读并同意购买协议');

            return;
          } // 保存购买人信息


          var _this5$form = _this5.form,
              buyer_name = _this5$form.buyer_name,
              buyer_phone = _this5$form.buyer_phone,
              buyer_identify = _this5$form.buyer_identify;
          order.buyer_name && _this5.$localStore.set('buyer_name', buyer_name);
          order.buyer_phone && _this5.$localStore.set('buyer_phone', buyer_phone);
          order.buyer_identify && _this5.$localStore.set('buyer_identify', buyer_identify);
          _this5.loading = true;
          createOrder(order).then(function (res) {
            _this5.$router.push({
              name: 'ticketPay',
              params: {
                id: res.data.extraInfo.id
              }
            });
          }).finally(function () {
            _this5.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    formatDate: function formatDate(input) {
      return dayjs(input).format('YYYY-MM-DD');
    },
    handleUpdate: function handleUpdate(contacts) {
      this.form.tickets = contacts;
    },
    getDisabledDate: function getDisabledDate(time) {
      /*
              通过当天下单限制判断是否可买今日
              is_book_today 是否当天下单
              book_today_endtime 当天下单截止时间
            */
      var today = null;

      if (this.ticketInfo.is_book_today && dayjs().isBefore(dayjs().format('YYYY-MM-DD') + ' ' + this.ticketInfo.book_today_endtime)) {
        today = dayjs().format('YYYY-MM-DD');
      } else {
        today = dayjs().add(1, 'days').format('YYYY-MM-DD');
      }

      var start = dayjs(this.ticketInfo.use_startdate).isAfter(today) ? this.ticketInfo.use_startdate : today; // book_future_days 可提前预定的天数

      var futureEnd = dayjs().add(this.ticketInfo.book_future_days, 'days').format('YYYY-MM-DD');
      var end = dayjs(this.ticketInfo.use_enddate).isBefore(futureEnd) ? this.ticketInfo.use_enddate : futureEnd;
      var startDisable = dayjs(time).isBefore(start);
      var endDisable = dayjs(time).isAfter(end);
      return startDisable || endDisable;
    }
  }
};